// extracted by mini-css-extract-plugin
module.exports = {"dashboardButton":"styles_dashboardButton__3RNQV","blue":"styles_blue__19rZX","gray":"styles_gray__Kxe4G","purple":"styles_purple__3Ueoj","fit":"styles_fit__3JRu_"};